import { format, parseISO } from 'date-fns'
import {
  Box,
  Flex,
  HStack,
  Image,
  Link,
  Text,
  Tooltip,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react'
import NextLink from 'next/link'
import { addSizeString } from '@/utils/addSizeString'

interface IProps {
  article: any
}

export const Article = ({ article }: IProps) => {
  let hrefAppend = ``
  const isBtcMiningIndex = article?.tags?.filter(
    (f: any) => f?.slug === 'hash-bitcoin-mining-index'
  )
  if (isBtcMiningIndex?.length > 0) {
    hrefAppend = `research/bitcoin-mining-index/`
  }

  return (
    <Box
      bg={useColorModeValue('lightModeBG', 'darkModeBG')}
      maxWidth={{ base: '100%', md: 'calc(50% - 24px)' }}
      width={{ base: '100%', md: '360px' }}
      minHeight={{ base: '', md: '220px' }}
      boxShadow="0 2px 7px hsla(0,0%,41.2%,.08)"
      borderRadius="10px"
      transition="box-shadow .3s ease"
      margin="0 12px 25px"
      cursor={'pointer'}
      _hover={{
        boxShadow: '0 4px 7px hsla(0,0%,41.2%,.28)',
      }}
    >
      {article?.feature_image && (
        <Box
          borderTopRadius="10px"
          width="100%"
          height={{ base: '', md: '200px' }}
        >
          <NextLink href={`/education/${hrefAppend}${article?.slug}`} passHref>
            <Link>
              <Image
                borderTopRadius="10px"
                width="100%"
                height="100%"
                objectFit="cover"
                objectPosition="center"
                src={addSizeString(article.feature_image, 'w600')}
                alt={article?.title}
              />
            </Link>
          </NextLink>
        </Box>
      )}
      <VStack
        padding="20px 25px 25px"
        width="100%"
        alignItems="flex-start"
        spacing="8px"
      >
        <NextLink href={`/education/${hrefAppend}${article?.slug}`} passHref>
          <Box as="a">
            <Text
              className="post-card-primary-tag"
              color={useColorModeValue(
                article?.primary_tag?.accent_color || 'brand.600',
                article?.primary_tag?.accent_color == '#000000'
                  ? 'white'
                  : article?.primary_tag?.accent_color || 'brand.600'
              )}
              fontSize="14px"
              fontWeight="bold"
              textTransform="capitalize"
            >
              {article?.primary_tag?.name}
            </Text>
            <Text fontSize="16px" fontWeight="700" lineHeight="1.56">
              {article?.title}
            </Text>
            <Box
              color={useColorModeValue('#4b5157', '#939699')}
              fontSize="14px"
              lineHeight="1.43"
              css={{
                display: '-webkit-box',
                WebkitLineClamp: '4',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {article?.excerpt}
            </Box>
          </Box>
        </NextLink>
        <HStack pt="10px" alignItems="center" spacing="12px">
          <HStack alignItems="center">
            <Box
              as="ul"
              display="flex"
              flexWrap="wrap"
              padding="0 !important"
              margin="0 !important"
              css={{
                listStyle: 'none !important',
              }}
            >
              {article?.authors?.map((author: any, i: number) => (
                <Box
                  key={`author-image-${i}`}
                  as="li"
                  cursor="pointer"
                  margin="0 -4px !important"
                  background="white"
                  padding="2px !important"
                  borderRadius="full"
                >
                  <Tooltip label={author?.name}>
                    <Box width="25px" height="25px">
                      <NextLink href={`/education/author/${author?.slug}`}>
                        <Link>
                          {author?.profile_image ? (
                            <Image
                              width="100%"
                              height="100%"
                              objectFit="cover"
                              borderRadius="100%"
                              src={addSizeString(author.profile_image, 'w600')}
                              alt={article?.name}
                            />
                          ) : (
                            <Box
                              width="25px"
                              height="25px"
                              bg="gray.400"
                              rounded="50%"
                            ></Box>
                          )}
                        </Link>
                      </NextLink>
                    </Box>
                  </Tooltip>
                </Box>
              ))}
            </Box>
            <Flex
              ml="1"
              fontSize="12px !important"
              textTransform="uppercase"
              css={{
                a: { color: useColorModeValue('black', 'white') },
              }}
              alignItems="center"
            >
              {article?.authors?.map((author: any) => (
                <Box
                  key={author?.slug}
                  _after={{
                    content: "','",
                  }}
                  css={{
                    '&:last-child:after': {
                      content: "''",
                    },
                  }}
                  textTransform="capitalize"
                >
                  <NextLink href={`/education/author/${author?.slug}`}>
                    {author?.name}
                  </NextLink>
                </Box>
              ))}
            </Flex>
          </HStack>
          <Text fontSize="12px" color="#939699">
            {format(parseISO(article?.published_at), 'MMM dd, yyyy')}
          </Text>
        </HStack>
      </VStack>
    </Box>
  )
}
